import type { TFunction } from "i18next";
import i18n from "../../core/i18n";

/** Structural match for Redux Toolkit SerializedError + our api.ts lifting. */
export interface ApiErrorLike {
  code?: string;
  message?: string;
}

/**
 * Resolution chain (each step falls through on miss — a raw key never renders):
 *  1. error.code set AND `errors:<code>` key exists  -> t("errors:<CODE>")
 *  2. error.message set                              -> server's English UserMessage
 *  3.                                                -> caller-supplied generic fallback
 */
export const translateApiError = (
  error: ApiErrorLike | null | undefined,
  t: TFunction,
  fallback: string
): string => {
  const code = error?.code;
  if (code && i18n.exists(`errors:${code}`)) {
    return t(`errors:${code}`);
  }
  return error?.message || fallback;
};
